var _config;

import { system } from '@styled-system/core';
var config = (_config = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  },
  borderTopWidth: {
    property: 'borderTopWidth',
    scale: 'borderWidths'
  },
  borderTopColor: {
    property: 'borderTopColor',
    scale: 'colors'
  },
  borderTopStyle: {
    property: 'borderTopStyle',
    scale: 'borderStyles'
  }
}, _config["borderTopLeftRadius"] = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
}, _config["borderTopRightRadius"] = {
  property: 'borderTopRightRadius',
  scale: 'radii'
}, _config.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
}, _config.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
}, _config.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
}, _config["borderBottomLeftRadius"] = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
}, _config["borderBottomRightRadius"] = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
}, _config.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
}, _config.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
}, _config.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
}, _config.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
}, _config.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
}, _config.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
}, _config);
export var border = system(config);
export default border;